import React from "react";
import { Box, Flex } from "@commonsku/design-system";

const CONNECTOR_LINE_BACKGROUND =
  "linear-gradient(to bottom, var(--chakra-colors-border-muted) 0 2px, transparent 2px 8px, var(--chakra-colors-border-muted) 8px 12px, transparent 12px 18px, var(--chakra-colors-border-muted) 18px 22px, transparent 22px 28px, var(--chakra-colors-border-muted) 28px 32px, transparent 32px 38px, var(--chakra-colors-border-muted) 38px 42px, transparent 42px 46px, var(--chakra-colors-border-muted) 46px 48px)";

/**
 * Visual connector between automation step panels.
 */
export const AutomationStepConnector = () => (
  <Flex align="center" height="20" justify="center" width="24">
    <Box backgroundImage={CONNECTOR_LINE_BACKGROUND} height="12" width="1px" />
  </Flex>
);

export default AutomationStepConnector;
